module.exports = __webpack_public_path__ + "media/images/icon_commentlist-e3cc58e8453673d26a9ff2b835a13f4f.svg";